import { createFileRoute } from "@tanstack/react-router";
import { Members } from "../../features/settings/members";

export const Route = createFileRoute("/_authed/$org/team/members")({ component: MembersPage });

function MembersPage() {
  return <Members org={Route.useParams().org} />;
}
